"use strict";
window.SHIGETA_THEME_CUSTOMIZE = window.SHIGETA_THEME_CUSTOMIZE || {};

(function($$) {
  // 送料無料バーアプリ 有効化チェック
  (function() {
    window.addEventListener('load', (e) => {
      let barAppUrl = 'https://free-shipping-bar-pr-js.firebaseapp.com/bar.js',
          scriptElementAll = document.querySelectorAll('script');
      [...scriptElementAll].forEach((scriptElement) => {
        if(scriptElement.src.indexOf(barAppUrl) !== -1) {
          document.body.classList.add('is-free-shipping-bar-enabled');
          if(theme && theme.config && theme.config.stickyHeader) {
            document.body.classList.add('is-sticky-header-enabled');
          }
        }
      });
    })
  })();
})(window.SHIGETA_THEME_CUSTOMIZE);